import { Provider } from "./ComposedProvider";

export function createProvider<T>(
  Component: React.ComponentType<React.PropsWithChildren<T>>,
  props?: Omit<T, "children">
): Provider<T> {
  return { Component, props };
}
